module.exports = __webpack_public_path__ + "static/media/amusement(12).46e89299.PNG";